import React, { Component } from 'react';
import PropTypes from 'prop-types';

import HeaderView from './HeaderView';
import SidebarView from './SidebarView';
import FlyoutContainer from './FlyoutContainer';
import Feedback from './Components/Feedback';

class PageView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuClosed: false,
    };
  }

  toggleMenu(state = null) {
    const { menuClosed } = this.state;
    this.setState({ menuClosed: state !== null ? state : !menuClosed });
  }

  render() {
    const { ChildView, menuItem = {}, payload = {} } = this.props;
    const menuClosed = this.state.menuClosed;

    if (payload.secondlevel === 'tv-mode') {
      return <ChildView {...this.props} {...menuItem} />;
    }

    return (
      <div className='container-fluid d-flex h-100 flex-column'>
        <div className='row'>
          <div className='col header'>
            <HeaderView
              {...this.props}
              menuClosed={menuClosed}
              toggleMenu={this.toggleMenu.bind(this)}
            />
          </div>
        </div>
        <div className='row fill d-flex justify-content-start'>
          <div className='row w-100' style={{ margin: 0 }}>
            <div
              className='sidebar'
              style={{
                width: '260px',
              }}
              data-menu-closed={menuClosed}
            >
              <SidebarView
                menuClosed={menuClosed}
                toggleMenu={this.toggleMenu.bind(this)}
                {...this.props}
              />
            </div>
            <div className='main-content-wrapper h-100 fill' style={{ overflowY: 'auto' }}>
              <ChildView {...this.props} {...menuItem} />
            </div>
            <div className='footer-gradient' />
          </div>
          <FlyoutContainer {...this.props} />
        </div>
        <Feedback payload={payload} />
      </div>
    );
  }
}

PageView.propTypes = {
  ChildView: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
  menuItem: PropTypes.shape({}),
  payload: PropTypes.shape({}),
};

PageView.defaultProps = {
  ChildView: <div />,
  menuItem: {},
  payload: {},
};

export default PageView;



// WEBPACK FOOTER //
// ./src/views/PageView.js